module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('card-news-item', {
    attrs: {
      "title": "Pagamento"
    }
  }, [(!_vm.calculo) ? _c('u-fake-loader', {
    staticClass: "m-t",
    attrs: {
      "width": "100%"
    }
  }) : _c('div', {
    staticClass: "row m-t"
  }, [(!_vm.preretiradas) ? _c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', [_vm._v("Inicie primeiro a pré-retirada para realizar a análise do pagamento.")])]) : _c('div', {
    staticClass: "col-xs-12"
  }, [(_vm.somaPagamentos > 0) ? _c('div', [_vm._l((_vm.preretiradas), function(preretirada) {
    return (preretirada.status === 1) ? _c('div', {
      staticClass: "row"
    }, [_c('div', {
      staticClass: "col-xs-6"
    }, [_vm._v(_vm._s(_vm.moment(preretirada.dataPagamento.date).format('L')))]), _vm._v(" "), _c('div', {
      staticClass: "col-xs-6 text-right font-bold"
    }, [_vm._v("R$ " + _vm._s(_vm._f("moeda")(preretirada.valor)))])]) : _vm._e()
  }), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12 m-t-n m-b-n"
  }, [_c('hr', {
    staticClass: "divider"
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 text-right"
  }, [_vm._v("\n              Total pago: "), _c('span', {
    staticClass: "m-l-xs font-bold text-success"
  }, [_vm._v("R$ " + _vm._s(_vm._f("moeda")(_vm.somaPagamentos)))])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 text-right"
  }, [_vm._v("Custo "), _c('small', [_vm._v("(" + _vm._s(_vm.calculo.base.diarias) + " diárias)")]), _vm._v(": "), _c('span', {
    staticClass: "m-l-xs font-bold text-primary"
  }, [_vm._v("R$ " + _vm._s(_vm._f("moeda")(_vm.calculo.base.custoAtualizado)))])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 text-right"
  }, [_vm._v("\n              Saldo Devedor: "), _c('span', {
    staticClass: "m-l-xs font-bold",
    class: _vm.calculo.base.saldoDevedor > 0 ? 'text-danger' : ''
  }, [_vm._v("R$ " + _vm._s(_vm._f("moeda")(_vm.calculo.base.saldoDevedor)))])])])], 2) : _c('div', [_vm._v("\n          Nenhum pagamento reconhecido. Execute a consulta de pagamento por referência e defina a pré-retirada como paga.\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "form-check m-t",
    staticStyle: {
      "padding-top": "7px"
    }
  }, [_c('label', {
    staticClass: "i-checks m-b-none",
    attrs: {
      "for": "pixManual"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.isPixManual),
      expression: "isPixManual"
    }],
    attrs: {
      "type": "checkbox",
      "id": "pixManual",
      "tabindex": "0",
      "aria-checked": "false",
      "aria-invalid": "false"
    },
    domProps: {
      "checked": Array.isArray(_vm.isPixManual) ? _vm._i(_vm.isPixManual, null) > -1 : (_vm.isPixManual)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.isPixManual,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.isPixManual = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.isPixManual = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.isPixManual = $$c
        }
      }
    }
  }), _c('i'), _vm._v("\n            Inserir PIX manualmente\n          ")])]), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.isPixManual) ? _c('div', [_c('div', {
    staticClass: "pix-codigo",
    attrs: {
      "id": "qr-code-printer"
    }
  }, [(_vm.qrCodeBase64) ? _c('img', {
    attrs: {
      "src": _vm.qrCodeBase64,
      "alt": "QR Code PIX"
    }
  }) : _c('div', [_vm._v("QR Code ainda não gerado")])]), _vm._v(" "), _c('div', {
    staticClass: "center-block text-center m-t hidden-print"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.valorPixManual),
      expression: "valorPixManual",
      modifiers: {
        "number": true
      }
    }, {
      name: "money",
      rawName: "v-money",
      value: (_vm.money),
      expression: "money"
    }],
    staticClass: "form-control input-sm center-block",
    staticStyle: {
      "max-width": "120px",
      "margin": "0 auto",
      "font-size": "14px",
      "text-align": "center"
    },
    attrs: {
      "placeholder": "Valor do Pix",
      "min": "0.01",
      "step": "0.01"
    },
    domProps: {
      "value": (_vm.valorPixManual)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.valorPixManual = _vm._n($event.target.value)
      },
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "m-t-xs",
    class: _vm.pixStatusClass,
    domProps: {
      "innerHTML": _vm._s(_vm.descricaoPix)
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "center-block text-center m-t-xs"
  }, [_c('button', {
    staticClass: "btn btn-info btn-block",
    on: {
      "click": _vm.geraCodigoPix
    }
  }, [_vm._v("Criar PIX manual")])]), _vm._v(" "), _c('div', {
    staticClass: "center-block text-center m-t-xs"
  }, [_c('button', {
    staticClass: "btn btn-info btn-block",
    on: {
      "click": _vm.getPixStatus
    }
  }, [_vm._v("Checar status PIX manual")])]), _vm._v(" "), _c('div', {
    staticClass: "center-block text-center m-t-xs"
  }, [_c('button', {
    staticClass: "btn btn-info btn-block",
    on: {
      "click": _vm.print
    }
  }, [_vm._v("Imprimir")])])]) : _vm._e()])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1691d4fa","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/website/grvs/components/grv-patio/CardNewsItemPagamento.vue
// module id = 1705
// module chunks = 18